import { IConfigurationQuestion } from 'types/ConfigurationQuestion.types';
import { IPredefinedPricing, IVariables } from '../reducers/model';
import {
  SET_MODEL,
  SET_QUESTIONS,
  RESET_CONFIGURE_FORM,
  SET_IMAGES,
  SET_PRICING,
  SET_LANG,
  SET_QUERY_PAYLOAD,
  SET_IS_USING_SELLER_SYSTEM_DISCOUNTS,
  SET_EXTRA_PRICE_QUESTIONS,
  SET_BOM_ITEMS,
  SET_VARIABLES,
  SET_CUSTOM_NET_PRICE,
  SET_RESET_DISCOUNT_LINES,
  SET_PREDEFINED_PRICING,
} from '../../constants';

export const setModel = (modelData: object) => ({
  type: SET_MODEL,
  payload: modelData,
});

// Setting questions from query response require some formatting in the reducer
export const setQuestions = (questionData: object) => ({
  type: SET_QUESTIONS,
  payload: questionData,
});

// Query payload is saved because it is also sent along when submitting the configuration
export const setQueryPayload = (queryPayload: object) => ({
  type: SET_QUERY_PAYLOAD,
  payload: queryPayload,
});

export const setImages = (imagesData: object) => ({
  type: SET_IMAGES,
  payload: imagesData,
});

export const setPricing = (pricingData: object) => ({
  type: SET_PRICING,
  payload: pricingData,
});

export const setCustomNetPrice = (
  customNetPrice: number | null | undefined
) => ({
  type: SET_CUSTOM_NET_PRICE,
  payload: customNetPrice,
});

export const setBomItems = (bomItemsData: object | undefined) => ({
  type: SET_BOM_ITEMS,
  payload: bomItemsData,
});

// The model variables, shown on SpecsPage. Only present in the query response
// for models the backend returns variables for.
export const setVariables = (variablesData: IVariables | undefined) => ({
  type: SET_VARIABLES,
  payload: variablesData,
});

// The language that was selected when the query was initiated
export const setLang = (lang: string) => ({
  type: SET_LANG,
  payload: lang,
});

export const resetConfigureForm = () => ({
  type: RESET_CONFIGURE_FORM,
});

export const setIsUsingSupplierSystemDiscounts = (bool: boolean) => ({
  type: SET_IS_USING_SELLER_SYSTEM_DISCOUNTS,
  payload: bool,
});

export const setExtraPriceQuestions = (
  extraPriceQuestions: IConfigurationQuestion[]
) => ({
  type: SET_EXTRA_PRICE_QUESTIONS,
  payload: extraPriceQuestions,
});

export const setResetDiscountLines = (resetDiscountLines: Set<string>) => ({
  type: SET_RESET_DISCOUNT_LINES,
  payload: resetDiscountLines,
});

// Currency + exchange rate from an existing quotation
export const setPredefinedPricing = (
  predefinedPricing: IPredefinedPricing | null
) => ({
  type: SET_PREDEFINED_PRICING,
  payload: predefinedPricing,
});
